module.exports = __webpack_public_path__ + "njit.1f72db555ed9f74b0b803d8f2c6e5f4b.webp";